import { useMemo } from 'react';

import { useAuth } from '../auth/AuthProvider';
import { decodeJwt, orgRoleFromClaims } from '../lib/jwt';

export type OrgRole = 'customer' | 'fde';

/**
 * Formant users get full console access; other domains default to customer.
 * Robotics-authenticated users are treated as FDE for now (see
 * `orgRoleFromClaims`).
 */
export function useOrgRole(): OrgRole {
  const { token } = useAuth();
  return useMemo(() => orgRoleFromClaims(decodeJwt(token)), [token]);
}
